import { Routes, Route } from "react-router-dom";
import CostTypes from "./CostTypes";
import CostTypeCreateEdit from "./CostTypeCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<CostTypes />} />
			<Route path='/create' element={<CostTypeCreateEdit />} />
			<Route path='/:id/edit' element={<CostTypeCreateEdit />} />
		</Routes>
	);
};

export default index;
